import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { InformationRequestDetailed } from '../interfaces/informationRequestDetailed.interface';

@Injectable()
export class InfoRequestService {
  constructor(
    private http: HttpClient,
    @Inject('API_URL') protected apiUrl: string,
    @Inject(LOCALE_ID) protected localeId: string) {
  }

  public getInfoRequest(id: string): Observable<InformationRequestDetailed> {
    return this.http.get<InformationRequestDetailed>(`${this.apiUrl}/InformationRequest/${id}`);
  }

  public sendResponse(requestId: string, message: string, files: File[]): Observable<boolean> {
    let formdata = new FormData();
    formdata.append("message", message);
    for(let ix = 0; ix < files.length; ix++)
      formdata.append("files", files[ix]);

    return this.http.post<boolean>(`${this.apiUrl}/InformationRequest/Message/${requestId}`, formdata);
  }
}
